import React from "react";
import { Sun, Moon } from "lucide-react";
import { useTheme } from "@/hooks/useTheme";

export const ThemeToggle = ({ className = "" }) => {
  const { theme, toggle } = useTheme();
  const isDark = theme === "dark";

  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={isDark ? "Switch to light mode" : "Switch to dark mode"}
      data-testid="theme-toggle"
      className={`inline-flex items-center justify-center h-11 w-11 rounded-full border border-current/20 hover:border-current/60 transition-colors ${className}`}
      style={{ borderColor: "currentColor", borderWidth: "1px", opacity: 0.85 }}
    >
      {isDark ? <Sun size={16} strokeWidth={1.4} /> : <Moon size={16} strokeWidth={1.4} />}
    </button>
  );
};

export default ThemeToggle;
